import { Avatar } from '@/components/Avatar';
import styled from '@emotion/styled';
import xw from 'xwind';
import { css } from '@emotion/react';
import { RoleTag } from '@/components/RoleTag';

export const Wrapper = styled.div(xw`flex flex-col sm:flex-row`);

export const PublishingTime = styled.time`
  ${xw`text-sm sm:text-lg`}
  color: #aeadad;
`;

export const Dot = styled.span(
  css([
    xw` hidden sm:block text-sm sm:text-lg`,
    css`
      color: #aeadad;
    `,
  ]),
);

export const TimeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.6225rem;
  align-items: baseline;
`;
export const AuthorAvatar = styled(Avatar)``;

export const AuthorName = styled.span(xw`text-sm sm:text-lg font-bold`);

export const TldrTag = styled(RoleTag)(xw`block sm:hidden`);
